import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useIsAnkrAdmin, useIsSalesUser } from '../../context/AuthContext';

const AdminNotFoundPage = () => {
  const isAnkrAdmin = useIsAnkrAdmin();
  const isSalesUser = useIsSalesUser();
  const location = useLocation();

  const homeLink = isSalesUser ? '/admin/sales/leads' : isAnkrAdmin ? '/admin' : '/';

  return (
    <>
      <div className="d-flex flex-column justify-content-center align-items-center text-center" style={{ minHeight: '80vh' }}>
        <img className="d-block mx-auto rounded-3 mb-4" src="/dist/assets/images/404_ankr.webp" alt="Ankr Health Dashboard 404" width={400} />
        <span className="text-xl mb-4">404, Captain</span>
        <p className="lead mb-4">We couldn&apos;t find our way to this location on our maps: <code>{location.pathname}</code></p>
        <p>It may have moved, never existed, or consumed by the Bermuda triangle.</p>
        <div className="mt-4">
          <Link to={homeLink} className="btn btn-primary">
            Navigate Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default AdminNotFoundPage;